import { lazy } from 'react';
import authRoles from '../../../auth/authRoles';

const Home = lazy(() => import('./Home'));

const homeConfig = {
  settings: {
    layout: {
      config: {
        mode: 'fullwidth',
        scroll: 'content',
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: true,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
      style: 'layoutMarketingV2',
    },
  },
  auth: authRoles.onlyGuest,
  routes: [
    {
      path: '/',
      element: <Home />,
      exact: true,
    },
  ],
};

export default homeConfig;